import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[libIKPDateInputMask]',
  standalone: true,
})
export class DateInputMaskDirective {
  @HostListener('input', ['$event'])
  onInput(event: InputEvent): void {
    const inputElement = event.target as HTMLInputElement;
    this.checkAllowedCharacters(inputElement);
    this.checkShortInput(inputElement);
  }

  private checkShortInput(inputElement: HTMLInputElement): void {
    const length = inputElement.value.length;
    const lastCharDot = inputElement.value.at(-1) === '.';

    if ((length === 2 || length === 5) && lastCharDot) {
      if (length === 2) {
        inputElement.value = '0' + inputElement.value;
      }
      if (length === 5) {
        inputElement.value = inputElement.value.slice(0, 3) + '0' + inputElement.value.slice(-2);
      }
    }
  }

  private checkAllowedCharacters(inputElement: HTMLInputElement): void {
    const allowedCharacters = /^[0-9.]*$/;
    const specialCharacters = /[,/-]/;

    if (specialCharacters.test(inputElement.value)) {
      inputElement.value = inputElement.value.replace(/[,/-]/g, '.');
      return;
    }

    if (!allowedCharacters.test(inputElement.value)) {
      inputElement.value = inputElement.value.replace(/[^0-9.]/g, '');
    }
  }
}
